// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"layout_pageContainer__1rE4M","fixedWidth":"layout_fixedWidth__2_Bij"};